// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb-2YHQm"};